export const GET_CHANNEL_METRICS_REQUEST = "GET_CHANNEL_METRICS_REQUEST";
export const GET_CHANNEL_METRICS_SUCCESS = "GET_CHANNEL_METRICS_SUCCESS";
export const GET_CHANNEL_METRICS_ERROR = "GET_CHANNEL_METRICS_ERROR";

export const SET_METRIC_PROJECT = "SET_METRIC_PROJECT";
export const SET_METRIC_CHANNEL = "SET_METRIC_CHANNEL";

export const RESET_METRICS = "RESET_METRICS";
